module.exports = __webpack_public_path__ + "media/near-miss.701fe08f.mp4";